export default "/kiban/_next/static/images/18_6L_other-c9f25ad16fc266ee48833c20ebcfe23e.png";